// extracted by mini-css-extract-plugin
export default {"root":"p7mLrLn08Dn5D1jllxH_","name":"ViBk5Iev2lRIahl2R5wg"};